import React, { useEffect } from 'react';

import PageContainer from 'Components/Atoms/PageContainer';
import WithDrawer from 'Components/Templates/WithDrawer';
import VendorForm from 'Components/Organisms/VendorForm';

const VendorSettings: React.FC = () => {
  useEffect(() => {
    document.title = 'Vendor Settings - Orion';
  }, []);

  return (
    <WithDrawer>
      <PageContainer>
        <VendorForm />
      </PageContainer>
    </WithDrawer>
  );
};

export default VendorSettings;
